import useData from './data-service'
import { Families } from '../types/data-types'

/**
 * Returns the families for the person's spouses and parents.
 */
export default function useFamilies(): Families | undefined {
  return useData()?.families
}
